// Main entry point for all chart types and utilities
import VChartWrapper from '../VChartWrapper';
import { createChart } from './factory';

// Chart implementations
import BarChart from './BarChart';
import LineChart from './LineChart';
import PieChart from './PieChart';
import AreaChart from './AreaChart';
import ScatterChart from './ScatterChart';
import RadarChart from './RadarChart';
import RoseChart from './RoseChart';
import BoxPlotChart from './BoxPlotChart';
import FunnelChart from './FunnelChart';
import WordCloudChart from './WordCloudChart';
import HeatmapChart from './HeatmapChart';
import MapChart from './MapChart';
import TreemapChart from './TreemapChart';
import SankeyChart from './SankeyChart';
import SunburstChart from './SunburstChart';
import GaugeChart from './GaugeChart';
import RangeChart from './RangeChart';
import ProgressChart from './ProgressChart';
import WaterfallChart from './WaterfallChart';
import CompositeChart from './CompositeChart';
import BaseChart from './BaseChart';

// Configuration utilities
import * as animations from '../config/animations';
import * as tooltips from '../config/tooltips';
import * as legends from '../config/legends';
import * as themes from '../config/themes';

// Export the main wrapper component as default
export default VChartWrapper;

// Export factory function
export { createChart };

// Export all chart types
export const ChartTypes = {
  Bar: BarChart,
  Line: LineChart,
  Pie: PieChart,
  Area: AreaChart,
  Scatter: ScatterChart,
  Radar: RadarChart,
  Rose: RoseChart,
  BoxPlot: BoxPlotChart,
  Funnel: FunnelChart,
  WordCloud: WordCloudChart,
  Heatmap: HeatmapChart,
  Map: MapChart,
  Treemap: TreemapChart,
  Sankey: SankeyChart,
  Sunburst: SunburstChart,
  Gauge: GaugeChart,
  Range: RangeChart,
  Progress: ProgressChart,
  Waterfall: WaterfallChart,
  Composite: CompositeChart,
  Base: BaseChart
};

// Export configuration utilities
export const Config = {
  animations,
  tooltips,
  legends,
  themes
};

// Helper function to create chart data structure (canonical format)
export const createChartData = (type, data, options = {}) => {
  return {
    chart_type: type,
    data,
    options
  };
};

// Enumeration of available chart types
export const CHART_TYPE = {
  BAR: 'bar',
  LINE: 'line',
  PIE: 'pie',
  AREA: 'area',
  SCATTER: 'scatter',
  RADAR: 'radar',
  ROSE: 'rose',
  BOXPLOT: 'boxplot',
  FUNNEL: 'funnel',
  WORDCLOUD: 'wordcloud',
  HEATMAP: 'heatmap',
  MAP: 'map',
  TREEMAP: 'treemap',
  SANKEY: 'sankey',
  SUNBURST: 'sunburst',
  GAUGE: 'gauge',
  RANGE: 'range',
  PROGRESS: 'progress',
  WATERFALL: 'waterfall',
  COMPOSITE: 'composite'
}; 